/**
 * Encodes an experiment's `groupingFilter` into the `?segment=` query value
 * the analytics service expects — a JSON-encoded filters map (e.g.
 * `{"filters":{"product_type":["Sweatpants"]}}`). Ky/URLSearchParams handle
 * the percent-encoding when the value is attached to a request, so callers
 * just pass the returned string straight through as the `segment` param.
 * Returns `undefined` for "no grouping" (`groupingFilter` null) so callers
 * can spread it into a params object without an explicit presence check.
 */

import type { DraftGroupingFilter } from '../types/experiment-draft.types';

export function encodeSegmentFilter(
  groupingFilter: DraftGroupingFilter | null | undefined,
): string | undefined {
  if (!groupingFilter) return undefined;
  return JSON.stringify({ filters: groupingFilter.filters });
}
